import React, { useState } from "react";
import logo from "../assets/logo.png";
import { Link as RouterLink, useLocation, useNavigate } from "react-router-dom";
import { useAuth } from "../context/AuthContext";
import lenis from "../lenis";
import PrivacyPolicy from "./Privacypolicy";
import Modal from "./Modal";

function Footer(){
    const[isPolicyOpen, setIsPolicyOpen] = useState(false);
    const {user, logout} = useAuth();
        const location = useLocation();
        const navigate = useNavigate();
    
        const handleScrollTo = (target) => {
            const scrollOptions = { offset: 0 }; // Definimos las opciones una sola vez
    
            if (location.pathname === '/') {
                lenis.scrollTo(target, scrollOptions);
            } else {
                // Pasamos tanto el ID como las opciones a la HomePage
                navigate('/', { state: { scrollToId: target, scrollOptions: scrollOptions } });
            }
        };

    return(
        <>
            <footer className="w-full bg-black text-gray-400 z-10">
                <div className="max-w-6xl mx-auto h-full flex flex-col justify-between py-4 px-4">
                    <div className="flex flex-col md:flex-row justify-between w-full py-10 gap-8 ">

                        <div className="flex flex-col items-start mb-2 md:mb-0 md:w-1/4"> {/* Ocupa 1/4 del ancho en md */}
                            <button onClick={() => handleScrollTo('#inicio')}>
                                <RouterLink to="/">
                                    <img src={logo} alt="Logo de Kifli Footer" className="h-16 w-auto" /> {/* Ajusta el tamaño h-16 (64px) */}
                                </RouterLink>
                            </button>
                            
                {/* Opcional: un pequeño eslogan o descripción debajo del logo */}
                {/* <p className="text-sm text-gray-500">Conectando tus compras.</p> */}
                        </div>

                        <div className="mb-6 md:mb-0 md:w-1/4"> {/* Ocupa 1/4 del ancho en md */}
                            <h3 className="text-white font-bold mb-3">Navegación</h3>
                            <ul className="space-y-2"> {/* Espacio entre ítems */}
                                <li><button onClick={() => handleScrollTo('#inicio' )} className="hover:text-white">Inicio</button></li>
                                <li><button onClick={() => handleScrollTo('#nosotros' )}>Sobre Nosotros</button></li>
                                <li><button onClick={() => handleScrollTo('#calculadora' )}>Calculadora</button></li>
                            </ul>
                        </div>

                        <div className="mb-6 md:mb-0 md:w-1/4"> {/* Ocupa 1/4 del ancho en md */}
                            <h3 className="text-white font-bold mb-3">Soporte</h3>
                            <ul className="space-y-2"> {/* Espacio entre ítems */}
                                <li><button onClick={() => handleScrollTo('#faq' )} className="hover:text-white">Preguntas Frecuentes</button></li>
                                <li><a href="https://api.whatsapp.com/send/?phone=593982968185&text&type=phone_number&app_absent=0" className="hover:text-white">Contacto</a></li>
                                <li>
                                    <button onClick={() => setIsPolicyOpen(true)} className="hover:text-white text-left">
                                        Políticas de Privacidad
                                    </button>
                                </li>
                            </ul>
                        </div>

                        <div className="md:w-1/4"> {/* Ocupa 1/4 del ancho en md */}
                            <h3 className="text-white font-bold mb-3">Redes Sociales</h3>
                            <ul className="space-y-2"> {/* Espacio entre ítems */}
                                <li><a href="https://www.instagram.com/kifli.ec?igsh=MW03cHczczAzeWUyYw%3D%3D&utm_source=qr" className="hover:text-white">Instagram</a></li>
                                <li><a href="https://www.facebook.com/share/1GUDj3LkXy/?mibextid=wwXIfr" className="hover:text-white">Facebook</a></li>
                                <li><a href="https://www.tiktok.com/@kifli.ec?_r=1&_t=ZM-91Tq8hH9MIS" className="hover:text-white">TikTok</a></li>
                            </ul>
                        </div>
                    </div>

                    <div className="border-t border-gray-800 pt-6 text-center w-full">
                        <p className="text-sm text-gray-600">© 2025 Kifli. Todos los derechos reservados.</p>
                    </div>
                </div>
            </footer>
            <Modal isOpen={isPolicyOpen} onClose={() => setIsPolicyOpen(false)}>
                <PrivacyPolicy />
            </Modal>
        </>
    )
}

export default Footer;
